<template>
  <div>
    <button
      class="base-expander"
      :aria-label="expanderLabel"
      @click="isExpanded = !isExpanded"
    >
      <div
        :class="[
          'base-expander__title',
          { 'base-expander__title--blue': withValidation }
        ]"
      >
        <div v-if="withValidation" class="validation">
          <valid-img v-if="isValid" class="validation__indicator" />
          <invalid-img v-else class="validation__indicator" />
        </div>
        {{ title }}
      </div>
      <chevron-img
        :class="[
          'base-expander__chevron',
          {
            expanded: isExpanded,
            'base-expander__chevron--black': !withValidation
          }
        ]"
      />
    </button>
    <div class="filter-content-container" :class="{ last }">
      <div class="filter-content" :class="{ hidden: !isExpanded }">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ValidImg from "@/assets/images/valid.svg";
import InvalidImg from "@/assets/images/invalid.svg";
import ChevronImg from "@/assets/images/chevron.svg";

export default {
  name: "BaseFilterExpander",
  components: {
    ValidImg,
    InvalidImg,
    ChevronImg
  },
  props: {
    title: {
      type: String,
      default: i18n.t("filter-expander.title")
    },
    isValid: {
      type: Boolean,
      default: false
    },
    withValidation: {
      type: Boolean,
      default: true
    },
    last: {
      type: Boolean
    }
  },
  data() {
    return {
      isExpanded: true
    };
  },
  computed: {
    expanderLabel() {
      return this.isExpanded
        ? this.$t("filter-expander.close-section")
        : this.$t("filter-expander.open-section");
    }
  }
};
</script>

<style scoped lang="scss">
.base-expander {
  display: flex;
  justify-content: space-between;
  padding: 22px 0;
  align-items: center;
  width: 100%;

  &__title {
    font-size: $font-size-xl;
    display: flex;
    margin: 0;

    &--blue {
      color: $color-blue-300;
    }
  }

  &__chevron {
    transform: rotate(180deg);

    &--black {
      fill: $color-black;
    }

    &.expanded {
      transform: rotate(0);
    }
  }
}

.validation {
  @include flex-centered();

  &__indicator {
    padding-bottom: 3px;
    margin-right: 18px;
  }
}

.filter-content-container {
  border-bottom: 1px solid $color-grey-100;

  .filter-content {
    margin-bottom: 30px;
    margin-top: 5px;

    &.hidden {
      display: none;
    }
  }

  &.last {
    border-bottom: 0;

    .filter-content {
      margin: 0;
    }
  }
}

@media screen and (min-width: $media-l) {
  .base-expander {
    padding: 42px 20px;
  }

  .filter-content-container .filter-content {
    margin-bottom: 50px;
  }
}
</style>
